{
  "remove": "Remove",
  "empty_option": "No matches found"
}
